<template>
  <div class="wrapper-question-popover">
    <b-icon
      icon="question-circle-fill"
      :id="`popover-question-${popoverKey}`"
      @click="show = !show"
    ></b-icon>
    <b-popover
      :show.sync="show"
      :target="`popover-question-${popoverKey}`"
      :variant="variant"
      triggers="focus hover"
    >
      <template #title>{{ sentenceCase(title) }}</template>
      <p class="text-normal">{{ sentenceCase(description) }}</p>
    </b-popover>
  </div>
</template>
<script>
import { sentenceCase } from '@/utils';

export default {
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    description: {
      type: String,
      default: 'loremp ipsum.....',
    },
    variant: {
      type: String,
      deafult: 'variant',
    },
    popoverKey: {
      type: String,
      default: 'popover',
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    sentenceCase,
  },
};
</script>
<style scoped lang="scss">
.wrapper-question-popover {
  p {
    text-transform: none;
  }
}
</style>
